import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const ADDRESS_INFO_PATH = 'address'

export function getListGenericAddress(path, userId, refCountry, refState) {
    let params = {
        userId: userId,
    }

    if (!!refCountry) {
        params.countryCode = refCountry

        if (!!refState) {
            params.stateCode = refState
        }
    }

    // address/getCountries || address/getStates || address/getCities
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${path}`, {
            params: params,
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

//#region Create Or Update
export function createOrUpdateAddressInfo(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${ADDRESS_INFO_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion
